import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { GAME_LIST } from 'src/constants/queryKeys';

export const networkGetGameInfo = async (gameId) => {
  const res = await axiosInstance.post(`Game/Info/${gameId}`);
  return res;
};

export function useFetchGameInfo(gameId) {
  return useQuery({
    queryKey: ['GAME_INFO', gameId],
    queryFn: () => networkGetGameInfo(gameId),
  });
}

export const networkGetGamesList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`Game/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchGamesList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [GAME_LIST, payload, pageIndex],
    queryFn: () => networkGetGamesList(payload, pageIndex, pageSize),
  });
}

export const networkCreateGame = async (data) => {
  const res = await axiosInstance.post('Game/Insert', data);
  return res;
};

export const networkUpdateGame = async (gameId, data) => {
  const res = await axiosInstance.post(`Game/Update/${gameId}`, data);
  return res;
};

export const networkRemoveGame = async (gameId) => {
  const res = await axiosInstance.post(`Game/Remove/${gameId}`);
  return res;
};

export const networkRemoveGameSimilar = async (gameId) => {
  const res = await axiosInstance.post(`GameSimilar/Remove/${gameId}`);
  return res;
};

export const networkInsertGameSimilar = async (payload) => {
  const res = await axiosInstance.post(`GameSimilar/Insert`, {
    ...payload,
  });
  return res;
};

// --------------------------------------------------------------------------------

export const networkGetGameCategoryList = async () => {
  const res = await axiosInstance.post('GameCategory/List');
  return res;
};

export const networkGetGameOrientationList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GameOrientation/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchOrientationList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['game-orientation-list', pageIndex, payload],
    queryFn: () => networkGetGameOrientationList(payload, pageIndex, pageSize),
  });
}

export const networkGetGameDesignModeList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GameDesignMode/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchGameDesignModeList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['game-design-mode-list', pageIndex, payload],
    queryFn: () => networkGetGameDesignModeList(payload, pageIndex, pageSize),
  });
}

export const networkGetGameModeList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GameMode/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchGameModeList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['game-mode-list', pageIndex, payload],
    queryFn: () => networkGetGameModeList(payload, pageIndex, pageSize),
  });
}

export const networkGetGameTypeList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GameType/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchGameTypeList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['game-type-list', pageIndex, payload],
    queryFn: () => networkGetGameTypeList(payload, pageIndex, pageSize),
  });
}
